import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  resultsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    width: '500px',
  },

  resultsSection: {
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    maxHeight: '15rem',
  },

  resultsHeader: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: theme.palette.secondary.main,
    margin: theme.spacing(4, 0),
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: theme.spacing(5),
  },

  summaryUrl: {
    textAlign: 'center',
  },

  urlText: {
    fontWeight: '700',
    textDecoration: 'none',
    color: theme.palette.white.main,
    fontSize: '1.4rem',
    lineHeight: '3rem',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.secondary.main,
    justifyContent: 'center',
    borderRadius: '35px',
    padding: theme.spacing(1.8),
    boxShadow: '-10px 12px 17px -4px rgba(0,0,0,0.76)',
  },

  downloadIcon: {
    fontSize: '2.4rem',
    marginLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.4),
    color: theme.palette.white.main,
  },

  listItem: {
    paddingLeft: theme.spacing(0),
  },

  listItemText: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(0),
    padding: theme.spacing(0.75, 1.25),
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    '& > p': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
      marginLeft: theme.spacing(2),
      color: theme.palette.secondary.main,
      fontWeight: '600',
    },
  },

}));

export default useStyles;
